<template>
  <div class="grid grid-cols-2 gap-4 p-4">
    <VerticalFoodCard
      v-for="product in menu.products"
      :key="product.id"
      :product="product"
    />
  </div>

  <div class="h-14"></div>

  <div class="fixed flex w-full bottom-16 px-4 py-2">
    <Button @click="submit">ادامه</Button>
  </div>
</template>

<script>
import { getSubMenu, checkOut } from "@/API/API";
import VerticalFoodCard from "@/components/VerticalFoodCard";
import Button from "@/components/General/Button";

export default {
  name: "ChooseFood",
  components: { Button, VerticalFoodCard },
  data() {
    return {
      menu: {},
    };
  },
  async created() {
    // only call first time we create this page, otherwise we use route watcher
    if (Object.keys(this.menu).length === 0)
      this.menu = (await getSubMenu(this.$route.params.id)).data.result;
  },
  methods: {
    submit() {
      if (this.$store.getters.isCartEmpty) {
        this.$swal({
          icon: "error",
          title: "خطا",
          text: "غذایی انتخاب نشده است.",
          confirmButtonColor: "#fcd34d",
          confirmButtonText: "باشه",
        });
      } else {
        let factor = this.$store.state.factor;
        factor.goods = this.$store.state.cart.products;
        checkOut(factor)
          .then((resp) => {
            let newP = resp.data.result;
            this.$store.dispatch("addNewFactor", newP);
            this.$router.push("/submit-order/receipt");
          })
          .catch(() => {
            this.$swal({
              icon: "error",
              title: "خطا",
              text: "عملیات با شکست مواجه شد",
              confirmButtonColor: "#fcd34d",
              confirmButtonText: "باشه",
            });
          });
      }
    },
  },
  //this.products = (await checkOut()).data.result;
  watch: {
    async $route() {
      this.menu = [];
      // Check the param so it doesnt send request on leaving the page (route changes on leave)
      if (this.$route.params.id)
        this.menu = (await getSubMenu(this.$route.params.id)).data.result;
    },
  },
};
</script>

<style scoped></style>
